class AsignacionService {
  constructor() {}

  resources = () => ({
    planillas: {
      uri: `/v1/planillas`,
      method: ['get']
    },
    trabajadores: {
      uri: `/v1/trabajadores/porasignar`,
      method: ['get']
    },
    posts: {
      uri: `/posts`,
      method: ['delete'],
      queryParams: {
        userId: 1
      }
    },
    distocupados: {
      uri: `/v1/unidadcampamento/distribucionocupados`,
      method: ['get']
    },
    predistribucion: {
      uri: `/v1/unidadcampamento/predistribucion`,
      method: ['get']
    },
    asignardistribucion: {
      uri: `/v1/unidadcampamento/asignar`,
      method: ['post']
    },
    bajaobservacion: {
      uri: `/v1/unidadcampamento/bajaobservacion`,
      method: ['put']
    },
    sectores: {
      uri: `/v1/sectoresxasig`,
      method: ['get']
    },
    aldeas: {
      uri: `/v1/unidadcampamento/aldeasxasig`,
      method: ['get']
    },
    carpas: {
      uri: `/v1/unidadcampamento/carpasxasig`,
      method: ['get']
    },
    habitaciones: {
      uri: `/v1/unidadcampamento/habitacionesxasig`,
      method: ['get']
    },
    camas: {
      uri: `/v1/unidadcampamento/camasxasig`,
      method: ['get']
    },
    unidadcampamento: {
      uri: `/v1/unidadcampamento/listarxunidadcampamento`,
      method: ['get']
    },
    sectoresPadres: {
      uri: `/v1/sectorespadres`,
      method: ['get']
    }
  });
}

export default AsignacionService;
